import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/purchases";
export { API };
export { inp, sel, d } from "@/lib/purchases";

export const K = `${API}/catalogue`;
export const card = "rounded-xl border border-white/[0.06] bg-[#151D2E]";
export const sub = "rounded-lg border border-white/[0.05] bg-slate-950/40";

export const CHECKLIST = [
  ["favourite", "Favourite", "★", "text-amber-300 bg-amber-500/15 border-amber-500/40"],
  ["to_buy", "To Buy", "🛒", "text-violet-200 bg-violet-500/20 border-violet-400/50"],
  ["check_price", "Check Price", "🔎", "text-sky-200 bg-sky-500/15 border-sky-500/40"],
  ["contact_supplier", "Contact Supplier", "📞", "text-orange-200 bg-orange-500/15 border-orange-500/40"],
  ["already_have", "Already Have", "✓", "text-emerald-200 bg-emerald-500/15 border-emerald-500/40"],
  ["not_needed", "No Longer Needed", "✕", "text-slate-400 bg-slate-800/60 border-slate-700"],
];
export const checklistMeta = (k) => CHECKLIST.find((c) => c[0] === k);
export const CAT_TONE = { used_parts: "text-violet-300 bg-violet-500/15 border-violet-500/40", materials: "text-emerald-300 bg-emerald-500/15 border-emerald-500/40", tools: "text-amber-300 bg-amber-500/15 border-amber-500/40", supplies: "text-sky-300 bg-sky-500/15 border-sky-500/40" };
export const SOURCE_TONE = { local_supplier: "bg-emerald-500/15 text-emerald-300", taobao: "bg-orange-500/15 text-orange-300", shopee: "bg-orange-500/15 text-orange-200", lazada: "bg-sky-500/15 text-sky-300", carousell: "bg-rose-500/15 text-rose-300", facebook: "bg-blue-500/15 text-blue-300", direct_contact: "bg-amber-500/15 text-amber-300", manufacturer: "bg-slate-700/60 text-slate-200", distributor: "bg-slate-700/60 text-slate-200", other: "bg-slate-800 text-slate-300" };

export const price = (v, cur = "SGD", unit = "") => {
  if (v === null || v === undefined || v === "") return "";
  const sym = { SGD: "S$", CNY: "¥", MYR: "RM", USD: "US$" }[cur] || "";
  return `${sym}${Number(v).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${unit ? ` / ${unit}` : ""}`;
};
export const tel = (p) => `tel:${(p || "").replace(/[^\d+]/g, "")}`;
export const wa = (p) => { const n = (p || "").replace(/[^\d]/g, ""); return `https://wa.me/${n.length === 8 ? "65" + n : n}`; };
export const photoSrc = (item) => (item?.photo_url ? `${API.replace(/\/api$/, "")}${item.photo_url}` : null);

export const EMPTY_ITEM = { item_name: "", category: "used_parts", subcategory: "", brand: "", vehicle_make: "", vehicle_model: "", vehicle_year: "", part_number: "", position: "", condition: "", notes: "",
  price: "", price_unit: "", price_currency: "SGD", price_last_checked: "", price_notes: "", checklist_status: "none", favourite: false };
export const EMPTY_SOURCE = { source_type: "local_supplier", source_type_other: "", supplier_id: "", supplier_name: "", contact_person: "", phone: "", whatsapp: "", email: "", price: "", price_unit: "", currency: "SGD", listing_url: "", notes: "", is_preferred: false };
const nul = (v) => (v === "" || v === undefined ? null : v);
export const itemBody = (f) => ({ ...f, price: nul(f.price), price_last_checked: nul(f.price_last_checked) });
export const sourceBody = (f) => ({ ...f, price: nul(f.price), supplier_id: nul(f.supplier_id) });
export const toItemForm = (c) => Object.fromEntries(Object.keys(EMPTY_ITEM).map((k) => [k, c[k] ?? EMPTY_ITEM[k]]));

export function useCatalogueConfig() {
  const [cfg, setCfg] = useState({ categories: [], source_types: {}, online_types: [], checklist: {}, conditions: [], positions: [], currencies: {} });
  useEffect(() => { axios.get(`${K}/config`).then(({ data }) => setCfg(data)).catch(() => {}); }, []);
  return cfg;
}

export function useItems(params, deps = []) {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${K}/items`, { params }).then(({ data }) => setRows(data)).catch(() => setRows([]));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, deps);
  return [rows, load];
}
